import { Navigate, Route } from "@solidjs/router";
import { type ParentProps, Show } from "solid-js";
import { useAuth } from "./auth/AuthContext.tsx";
import { AppShell } from "./components/AppShell.tsx";
import { ApiKeys } from "./pages/ApiKeys.tsx";
import { Deliveries } from "./pages/Deliveries.tsx";
import { Login } from "./pages/Login.tsx";
import { Transactions } from "./pages/Transactions.tsx";
import { Webhooks } from "./pages/Webhooks.tsx";

/** Gate the protected routes behind a live session; otherwise redirect to /login. */
function ProtectedShell(props: ParentProps) {
  const { session } = useAuth();
  return (
    <Show when={session()} fallback={<Navigate href="/login" />}>
      <AppShell>{props.children}</AppShell>
    </Show>
  );
}

const RedirectToApiKeys = () => <Navigate href="/api-keys" />;

/** Route table. Everything but `/login` requires a session and shares the shell. */
export function App() {
  return (
    <>
      <Route path="/login" component={Login} />
      <Route path="/" component={ProtectedShell}>
        <Route path="/" component={RedirectToApiKeys} />
        <Route path="/api-keys" component={ApiKeys} />
        <Route path="/webhooks" component={Webhooks} />
        <Route path="/deliveries" component={Deliveries} />
        <Route path="/transactions" component={Transactions} />
        <Route path="*" component={RedirectToApiKeys} />
      </Route>
    </>
  );
}
